import React, { useContext } from 'react'
import { Redirect } from 'react-router-dom'
import { LayoutWrapper } from './wrapper/Wrapper'
import { sessionContext } from '@marketing-milk/frontend'

export function UserLayout(props: { children: any; className?: string }) {
  const { user } = useContext(sessionContext)

  if (!user) {
    return <Redirect to="/login" />
  }

  return (
    <LayoutWrapper>
      <div className={`flex h-full min-h-0 flex-col ${props.className ?? ''}`}>
        {props.children}
      </div>
    </LayoutWrapper>
  )
}
